module.exports = __webpack_public_path__ + "img/my-think-gold.a3d1976b.png";